import { Box, Typography } from "@mui/material";
import { StyledInfo } from "./Info.styled";
import image from "../../Images/Anja2.jpg";

export const Info = () => {
  return (
    <StyledInfo>
      <Box className="header">
        <Typography variant="h1">Info</Typography>
      </Box>
      <Box className="content">
        <Box className="imageWrapper">
          <img src={image} />
        </Box>
        <Box className="divider" />
        <Box className="text">
          <Typography variant="body1">
            Kunst - en schilderen in het bijzonder - is voor mij altijd een
            diepe, innerlijke passie geweest. Sinds 2018 is het uitgegroeid tot
            een uit de hand gelopen hobby waar ik enorm veel energie van krijg.
          </Typography>
          <Typography variant="body1">
            Schilderen geeft me de ruimte om gevoelens, indrukken en thema's die
            mij raken om te zetten in kleur, vorm en beweging. Daardoor voelen
            mijn schilderijen krachtig, energierijk en veelzeggend. Elk werk
            vertelt een eigen verhaal, gedragen door symboliek en intuïtieve
            expressie.
          </Typography>
          <Typography variant="body1">
            In mijn schilderstijl komen abstracte vormen, lijnen, structuren en
            figuren samen in levendige, felle kleuren. Ik werk in meerdere
            verflagen - soms tot zes lagen per vorm - waardoor elk schilderij
            intens en zorgvoldig opgebouwd is.
          </Typography>
          <Typography variant="body1">
            Soms kies ik voor <i>dotpainting</i> als afwerking: een meditatieve
            stiptechniek die rust en focus brengt. De ritmische stippen voegen
            diepte toe en geven mijn werken een aards, inspirerend karakter.
          </Typography>
          <Typography variant="body1">
            Mijn kunst nodigt je uit om te kijken, te voelen en je te laten
            meenemen door kleur en betekenis. Laat je inspireren door wat je
            ziet - en missschien ook door wat je voelt.
          </Typography>
          <Typography variant="body1">Anja</Typography>
        </Box>
      </Box>
    </StyledInfo>
  );
};
